// extracted by mini-css-extract-plugin
export default {"row":"App_row__-vzSq","main":"App_main__nhgh3"};